export const DataKeluhan = {
  channel:
    `<b>Kanal resmi OJK</b> yaitu Aplikasi Portal Perlindungan Konsumen (“APPK”)
     untuk penanganan Pengaduan sesuai dengan kewenangan OJK.`,

  mediation:
    `<b>Mediasi</b> lewat Lembaga Alternatif Penyelesaian Sengketa Sektor Jasa Keuangan (“LAPS SJK”)
     yang telah memperoleh persetujuan OJK dan ditetapkan menurut peraturan OJK yang berlaku. 
     (<a style="color:#337BC4; font-weight:bold" href="https://www.homecredit.co.id/info/lapssjk">https://www.homecredit.co.id/info/lapssjk</a>).`
};
